module.exports = __webpack_public_path__ + "static/media/deeplearning-logo.708dc08e.png";